/*
 * @Author: minihorse
 * @Date: 2020-12-09 15:30:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-09 15:41:22
 * 
 */
const Layout = () => import('../pages/layout')
// const Mobile = () => import('../pages/layout/mindex')
const Section = () => import(/* webpackChunkName:'second' */ '../pages/layout/section')
const staticRoutes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: () => import(/* webpackChunkName:'second' */ '../pages/login/index.vue')
    },
    {
        path: '/wxlogin',
        component: () => import(/* webpackChunkName:'second' */ '../pages/login/wxlogin.vue')
    },
    {
        path: '/mobile',
        component: () => import(/* webpackChunkName:'second' */ '../pages/login/mobile.vue')
    },
    // {
    //     path: '/index',
    //     redirect: '/index/index'
    // },
    // {
    //     path: '/mindex',
    //     redirect:'/mbaobei/list'
    // },
    {
        path: '/index',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '综合首页'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/index/index')
            },
        ]
    },
    {
        path: '/kaohe',
        component: Layout,
        children: [
            {
                path: 'index',
                component: Section,
                children: [
                    {
                        path: 'index',
                        meta: {
                            title: '员工考核系统'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/index/index')
                    }
                ]
            },
            {
                path: 'employee',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '员工列表'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/employee/list')
                    },
                    {
                        path: 'group',
                        meta: {
                            title: '员工组'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/employee/group')
                    }
                ]
            },
            {
                path: 'menu',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '菜单'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/menu/list')
                    }
                ]
            },
            {
                path: 'assessment',
                component: Section,
                children: [
                    {
                        path: 'self',
                        meta: {
                            title: '考核自评'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/assessment/self')
                    },
                    {
                        path: 'departmentlist',
                        meta: {
                            title: '部门自评'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/departassess/selflist')
                    },
                    {
                        path: 'department/:id',
                        meta: {
                            title: '部门自评填报'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/departassess/self')
                    },
                    {
                        path: 'list',
                        meta: {
                            title: '员工考核'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/assessment/list')
                    },
                    {
                        path: 'leaderdeplist',
                        meta: {
                            title: '部门考核'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/departassess/leaderlist')
                    },
                    {
                        path: 'viewmember',
                        meta: {
                            title: '员工历史考核记录'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/viewass/list')
                    },
                    {
                        path: 'viewdepartment',
                        meta: {
                            title: '部门历史考核记录'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/viewass/department')
                    },
                    {
                        path: 'excellent',
                        meta: {
                            title: '优秀统计'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/viewass/excellent')
                    },
                    {
                        path: 'finallist',
                        meta: {
                            title: '成员考核审核'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/assessment/finallist')
                    },
                    {
                        path: 'finaldeplist',
                        meta: {
                            title: '部门考核审核'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/departassess/finallist')
                    },
                    {
                        path: 'vote',
                        meta: {
                            title: '优秀投票'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/vote/list')
                    },
                ]
            },
            {
                path: 'setting',
                component: Section,
                children: [
                    {
                        path: 'department',
                        meta: {
                            title: '部门管理'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/setting/department')
                    },
                    {
                        path: 'template',
                        meta: {
                            title: '模板自评'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/setting/template')
                    },
                ]
            },
            {
                path: 'vote',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '个人优秀'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/vote/list')
                    },
                    {
                        path: 'department',
                        meta: {
                            title: '部门优秀'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/vote/department')
                    },
                    {
                        path: 'getvoting',
                        meta: {
                            title: '未投票统计'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/kaohe/vote/getvoting')
                    },
                ]
            },
        ]
    },
    {
        path: '/baobei',
        component: Layout,
        children: [
            {
                path: 'index',
                component: Section,
                children: [
                    {
                        path: 'index',
                        meta: {
                            title: '员工报备系统'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/index/index')
                    }
                ]
            },
            {
                path: 'baobei',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '个人报备'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/baobei/list')
                    },
                    {
                        path: 'gonghai',
                        meta: {
                            title: '公海报备'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/baobei/gonghai')
                    },
                    {
                        path: 'shenhe',
                        meta: {
                            title: '审核报备'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/baobei/shenhe')
                    },
                ]
            },
            {
                path: 'employee',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '员工列表'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/employee/list')
                    },
                ]
            },
            {
                path: 'menu',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '菜单'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/menu/list')
                    }
                ]
            },
            {
                path: 'setting',
                component: Section,
                children: [
                    {
                        path: 'list',
                        meta: {
                            title: '参数设置'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/setting/list')
                    },
                    {
                        path: 'delay',
                        meta: {
                            title: '报备延期'
                        },
                        component: () => import(/* webpackChunkName:'second' */ '../pages/baobei/setting/delay')
                    },
                ]
            },
        ]
    },
    {
        path: '/employee',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '员工列表'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/employee/list')
            },
        ]
    },
    {
        path: '/department',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '部门列表'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/department/list')
            },
        ]
    },
    {
        path: '/operator',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '操作员列表'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/operator/list')
            },
            {
                path: 'group',
                meta: {
                    title: '会员组列表'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/operator/group')
            },
        ]
    },
    {
        path: '/setting',
        component: Layout,
        children: [
            { // 总管理员设置全局参数
                path: 'list',
                meta: {
                    title: '参数设置'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/setting/list')
            },
            { // 总管理员设置全局参数
                path: 'annualleave',
                meta: {
                    title: '年假设置'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/setting/annualleave')
            },
        ]
    },
    {
        path: '/record',
        component: Layout,
        children: [
            {
                path: 'login',
                meta: {
                    title: '操作员登录记录'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/record/login')
            },
        ]
    },
    /* 本段代码放在最后，未设置路由的地址跳转404 */
    {
        path: '*',
        redirect: '/404'
    },
    {
        path: '/404',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '页面不存在'
                },
                component: () => import(/* webpackChunkName:'second' */ '../pages/404')
            },
        ]
    },
    /** 本段代码放在最后，未设置路由的地址跳转404 */
]
export default staticRoutes